import * as React from 'react';

import { WalkScoreViewModel } from 'src/common/models';

import { WalkScore } from 'components/infosite/whats-around/internals/walk-score';

interface NearbyListProps {
  outerClass?: string;
  title?: string;
  walkScoreModel?: WalkScoreViewModel;
}

export const NearbyList: React.FC<NearbyListProps> = ({ title, outerClass, walkScoreModel, children }) => {
  if (!title) {
    return null;
  }

  return (
    <div className={outerClass}>
      <div className="uitk-flex uitk-flex-justify-content-space-between uitk-flex-align-items-flex-end">
        <h4 className="uitk-type-heading-500">{title}</h4>
        {walkScoreModel && <WalkScore model={walkScoreModel} />}
      </div>
      {children}
    </div>
  );
};

NearbyList.displayName = 'NearbyList';
